<app-announcements></app-announcements>
<!-- fixed-top -->
<!-- <app-main-navbar *ngIf="this.showMainNavBar" />
<app-header-funnel *ngIf="!this.showMainNavBar" />
<minimal-navbar-component *ngIf="this.showMinimalBar" /> -->
@switch(this.navbarToShow){
@case("funnel"){
<app-header-funnel />
}
@case("minimal"){
<minimal-navbar-component />
}
@default{
<app-main-navbar />
}
}